import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
/**
 * Generated class for the ColorClarityComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'color-clarity',
  templateUrl: 'color-clarity.html',
  styleUrls: ['./color-clarity.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class ColorClarityComponent {

  constructor() { }

}
